

export const firebaseConfig = {
	apiKey:  process.env.REACT_APP_FIREBASE_KEY,
    authDomain: "home-subscription.firebaseapp.com",
    databaseURL: "https://home-subscription-default-rtdb.firebaseio.com",
    projectId: "home-subscription",
    storageBucket: "home-subscription.appspot.com",
    messagingSenderId: "1056712067303",
    appId: "1:1056712067303:web:6c2123711a1f89a40a7a42",
    measurementId: "G-LNSZYMZ8TQ"
}


